export default __webpack_public_path__ + "static/media/Babyshoot.ab1fe465.jpg";